$(document).ready(function(){
	console.log($(document).foundation());
});
